export enum Services {
  'UNKNOWN_SERVICE' = -1,
  'FIGMA' = 0,
  'STRAPI' = 1,
  'ZAPIER' = 2,
  'STORYBLOK' = 3,
  'INTERCOM' = 4,
  'DIRECTUS' = 5,
  'ZENDESK' = 6,
  'IN_CONTEXT_EDITOR' = 7,
}
